<template>
  <div class="menu">
    <div
      :class="['menu-item', [selectedMenu == 'login' ? ' menu-selected' : '']]"
      @click="handleMenuSelect('login')"
    >
      {{ $t('login.loginTitle') }}
    </div>
    <div>|</div>
    <div
      :class="[
        'menu-item',
        [selectedMenu == 'register' ? ' menu-selected' : '']
      ]"
      @click="handleMenuSelect('register')"
    >
      {{ $t('login.registerLink') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedMenu: String
  },
  methods: {
    handleMenuSelect(menu) {
      if (menu !== this.selectedMenu) {
        this.$router.push(`/${menu}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  padding: 25px 0px;
  display: flex;
  justify-content: space-evenly;
  color: $login-menu;

  .menu-item {
    font-weight: 700;
    text-decoration: underline;
  }
  .menu-item:hover {
    cursor: pointer;
  }

  .menu-selected {
    color: $login-menu-selected;
  }
}
</style>
